import { render, staticRenderFns } from "./CapCubeLayout.vue?vue&type=template&id=25b06c4c&scoped=true"
import script from "./CapCubeLayout.vue?vue&type=script&lang=js"
export * from "./CapCubeLayout.vue?vue&type=script&lang=js"
import style0 from "./CapCubeLayout.vue?vue&type=style&index=0&id=25b06c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b06c4c",
  null
  
)

export default component.exports